import { Show } from "@clerk/react";
import { useClerkAvailable } from "@/components/auth/ClerkAuthProvider";
import { useLocalAuth } from "@/components/auth/LocalAuth";

// Local e-posta+şifre girişi varsa onu esas alır; yoksa Clerk aktifken <Show>,
// Clerk de yoksa "signed-out" içeriği görünür.
export function AuthShow({ when, children }) {
  const available = useClerkAvailable();
  const { user, loading } = useLocalAuth();
  if (loading) return null;
  if (user) return when === "signed-in" ? children : null;
  if (available) return <Show when={when}>{children}</Show>;
  return when === "signed-out" ? children : null;
}
